import { Box,Button, Grow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableSortLabel, TableRow, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getAMOrderList, getAMGetOrderDetailById, deleteOrderAM } from "../../store/actions/AMActions";
import { useDispatch, useSelector } from "react-redux";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

function AutonomousMaintenanceOrderList(props) {
    let [rows, setRows] = useState([]);
    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");

    useEffect(() => {
        LoadHandler();
    }, []);

    const { amOrderList, amOrderById, amOrderDelete } = useSelector(({ am }) => am);

    useEffect(() => {
        if (amOrderList?.resultObject) {
            setRows(Object.values(amOrderList.resultObject.content));
            setPageLoaded(true);
        }
    }, [amOrderList]);

    useEffect(() => {
        if (amOrderById?.resultObject) {
            let list = [];
            amOrderById.resultObject.taskDates.forEach((element) => {
                list.push(moment(element).format("DD.MM.YYYY"));
            });
            alert(list.join("\n"));
        }
    }, [amOrderById]);

    useEffect(() => {
        if (amOrderDelete?.resultObject) {
            ToggleModal();
            LoadHandler();
        }
    }, [amOrderDelete]);

    const LoadHandler = () => {
        dispatch(getAMOrderList());
    };

    //delete
    const DeleteHandler = (row) => {
        dispatch(deleteOrderAM(row.id));
    };

    //filter plant table
    const [filterText, setFilterText] = useState("");
    const FilterEquipment = (e) => {
        setFilterText(e.target.value.toLowerCase());
    };
    let filteredItems = rows.filter(
        (item) => item && (item.equipmentName.toLowerCase().includes(filterText) || item.equipmentDetailedCode.toLowerCase().includes(filterText) || item.notes.toLowerCase().includes(filterText))
    );

    //pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const HandleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const HandleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const NavigateToCreatePage = () => {
        props.history.push("/create-autonomous-maintenance-order?from=list");
    };

    const NavigateAsEditable = (id) => {
        props.history.push("/create-autonomous-maintenance-order?from=list&id=" + id);
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const DeleteButtonHandler = (row) => {
        setDeletedRow(row);
        ToggleModal();
    };

    const ToggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (row, column) => {
        setSortOrder(commonSort(row, column)[0]);
        setSortColumn(commonSort(row, column)[1]);
        filteredItems = commonSort(row, column)[2];
    };

    const ShowDates = (id) => {
        let payload = {
            id: id,
        };
        dispatch(getAMGetOrderDetailById(payload));
    };

    const renderTableCell = (rowItems, isSortingAction = false) => {
        return rowItems.map((item, index) => {
            return isSortingAction ? (
                <TableCell id={`amol_TableCell_2_${index}`} align="center">
                    <TableSortLabel
                        id={`amol_TableSortLabel_${index}`}
                        active={sortColumn === item.id}
                        direction={sortOrder === 1 ? "asc" : "desc"}
                        onClick={() => handleSort(rows, item.id)}
                        style={{ paddingLeft: 25 }}
                    >
                        {item.label}
                    </TableSortLabel>
                </TableCell>
            ) : (
                <TableCell id={`amol_TableCell_2_${index}`} align="center">
                    {item.label}
                </TableCell>
            );
        });
    };

    return (
        <StyledTableDiv>
            <h1>{t("AutonomousMaintenancePlans")}</h1>
            <AddButton onClick={() => NavigateToCreatePage()} />
            {pageLoaded === true ? (
                <React.Fragment>
                    <TextField id="amol_TextField" onChange={FilterEquipment} label={t("SearchMaintenancePlan")} variant="outlined" style={{ width: "40%" }} />
                </React.Fragment>
            ) : null}
            <Box m={2} />
            {rows.length > 0 ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer id="amol_TableContainer" component={Paper}>
                        <Table id="amol_Table" aria-label="customized table">
                            <TableHead id="amol_TableHead">
                                <TableRow id="amol_TableRow">
                                    {renderTableCell(
                                        [
                                            { id: "id", label: t("ID") },
                                            { id: "equipmentDetailedCode", label: t("EquipmentCode") },
                                            { id: "equipmentName", label: t("EquipmentName") },
                                            { id: "maintenanceTypeName", label: t("MaintenanceType") },
                                            { id: "notes", label: t("MaintenanceNote") },
                                            { id: "maintenanceDates", label: t("MaintenanceDates") },
                                            { id: "actions", label: t("Actions") },
                                        ],
                                        true
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody id="amol_TableBody">
                                {filteredItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                    <TableRow id={`amol_TableRow_2_${index}`} key={row.id}>
                                        <TableCell id={`amol_TableCell_id`} align="center">
                                            {row.id}
                                        </TableCell>
                                        <TableCell id={`amol_TableCell_equipmentDetailedCode`} align="center">
                                            {row.equipmentDetailedCode}
                                        </TableCell>
                                        <TableCell id={`amol_TableCell_equipmentName`} align="center">
                                            {row.equipmentName}
                                        </TableCell>
                                        <TableCell id={`amol_TableCell_maintenanceTypeName`} align="center">
                                            {row.maintenanceTypeName}
                                        </TableCell>
                                        <TableCell id={`amol_TableCell_notes`} align="center">
                                            {row.notes}
                                        </TableCell>
                                        <TableCell id={`amol_TableCell_ShowDates`} align="center">
                                            <Button id={`amol_b_${index}`} onClick={() => ShowDates(row.id)} variant="contained" color="primary">
                                                {" "}
                                                {t("SeeDates")}{" "}
                                            </Button>
                                        </TableCell>
                                        <TableButtons
                                            id={`amol_TableButtons`}
                                            row={row}
                                            enableEditHandler={() => NavigateAsEditable(row.id)}
                                            deleteButtonHandler={() => DeleteButtonHandler(row)}
                                            detail={false}
                                        />
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            id="amol_TablePagination"
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={HandleChangePage}
                            onRowsPerPageChange={HandleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}
            <Modal id="amol_m" title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => DeleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={ToggleModal} />
            <LoadingBackdrop id="amol_lbd" />
        </StyledTableDiv>
    );
}

export default withRouter(AutonomousMaintenanceOrderList);
